// src/api/settings/user-types.js
import axiosInstance from "../axiosInstance";

// const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
// const BASE_URL = `${API_BASE}/user_types`;

const BASE_URL = "/settings/user_types";

// Lấy tất cả user types (có thể truyền params để filter/paginate nếu cần)
export const getUserTypes = async (params) => {
  const { data } = await axiosInstance.get(BASE_URL, { params });
  return data; // => [{ id, name, description }, ...]
};

// (tuỳ chọn) Lấy 1 user type theo id
export const getUserType = async (id) => {
  const { data } = await axiosInstance.get(`${BASE_URL}/${id}`);
  return data; // => { id, name, description }
};
